import React from 'react'
import { Grid } from '../../common/grid/Grid'
import { GridItem } from '../../common/grid/GridItem'
import { Dropdown, Field, Option } from '@fluentui/react-components'
import { t } from '../../../i18n/i18n'
import { Role, SubscriptionAndUsersDTO } from '../../../api/schemas/schema'
import { UserAvatarOutput } from '../../common/inputs/UserAvatarOutput'
import { Control, Controller, useFieldArray, UseFormGetValues } from 'react-hook-form'

type SubscriptionUserRolesProps = {
   control: Control<SubscriptionAndUsersDTO>
   getValues: UseFormGetValues<SubscriptionAndUsersDTO>
   disabled?: boolean
}

export const SubscriptionUserRoles = ({ control, getValues, disabled }: SubscriptionUserRolesProps) => {
   const { fields } = useFieldArray({
      control,
      name: 'userAccounts',
   })
   const roleOptions = [
      { role: Role.SystemAdministrator, label: t('SystemAdministrator') },
      { role: Role.User, label: t('User') },
   ]

   return (
      <div>
         {fields.map((ua, index) => (
            <Grid key={ua.id}>
               <GridItem size="6/12">
                  <UserAvatarOutput userAccount={ua} />
               </GridItem>
               <GridItem size="6/12">
                  <Controller
                     control={control}
                     name={`userAccounts.${index}.role`}
                     rules={{
                        validate: () => {
                           const currentUsers = getValues('userAccounts')
                           return currentUsers.some((f) => f.role === Role.SystemAdministrator) || t('AtleastOneUserMustBeSystemAdministrator')
                        },
                     }}
                     render={({ field, fieldState: { error } }) => (
                        <Field validationMessage={error?.message} validationState={error ? 'error' : null}>
                           <Dropdown
                              selectedOptions={[field.value?.toString() ?? '']}
                              value={roleOptions.find((opt) => opt.role === field.value)?.label ?? ''}
                              onOptionSelect={(_, data) => {
                                 const selectedRole = Object.values(Role).find((r) => r.toString() === data.optionValue) as Role
                                 field.onChange(selectedRole)
                              }}
                              disabled={disabled}
                           >
                              {roleOptions.map((opt) => (
                                 <Option key={opt.role} value={opt.role.toString()}>
                                    {opt.label}
                                 </Option>
                              ))}
                           </Dropdown>
                        </Field>
                     )}
                  />
               </GridItem>
            </Grid>
         ))}
      </div>
   )
}
